// The "loose" audio metric preset value was renamed to "lenient". Stored metrics
// may still carry "loose", so normalize on read to keep the preset selector in sync.
export const normalizeLegacyPresetValue = (
  value: string | undefined,
): string | undefined => (value === "loose" ? "lenient" : value)
